import { render, staticRenderFns } from "./line.vue?vue&type=template&id=335917b3&"
import script from "./line.vue?vue&type=script&lang=js&"
export * from "./line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiMarketLineDetails: require('/var/web/bet777.es/themes/dark/ui/Market/LineDetails.vue').default,UiMarketLineOdds: require('/var/web/bet777.es/themes/dark/ui/Market/LineOdds.vue').default,UiMarketLineCount: require('/var/web/bet777.es/themes/dark/ui/Market/LineCount.vue').default,UiMarketLine: require('/var/web/bet777.es/themes/dark/ui/Market/Line.vue').default})
